import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineEllipsisVertical } from "react-icons/hi2";

interface DropdownMenuProps {
  onSetCurrentPlaylist: () => void;
  onInviteToEvent: () => void;
  onSearchAddSongs: () => void;
  isCurrentPlaylist: boolean;
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  onSetCurrentPlaylist,
  onInviteToEvent,
  onSearchAddSongs,
  isCurrentPlaylist,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const menuItemClass =
    "block px-4 py-2.5 text-sm text-gray-700 dark:text-gray-300 w-full text-left hover:bg-[#5932EA]/10 dark:hover:bg-[#5932EA]/20 rounded-lg transition-colors";

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className="inline-flex items-center justify-center gap-2 rounded-xl border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 shadow-sm px-5 py-2.5 text-sm font-medium hover:bg-gray-50 dark:hover:bg-gray-700 hover:border-gray-300 dark:hover:border-gray-500 transition-all focus:outline-none focus:ring-2 focus:ring-[#5932EA]/30"
      >
        <HiOutlineEllipsisVertical className="w-5 h-5" />
        {t("actions")}
      </button>

      {isOpen && (
        <div className="origin-top-right absolute right-0 mt-2 w-56 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800 py-1.5 z-20">
          <button
            onClick={() => {
              onSetCurrentPlaylist();
              setIsOpen(false);
            }}
            className={menuItemClass}
          >
            {isCurrentPlaylist ? t("currentPlaylist") : t("setCurrentPlaylist")}
          </button>
          <button
            onClick={() => {
              onInviteToEvent();
              setIsOpen(false);
            }}
            className={menuItemClass}
          >
            {t("inviteToEvent")}
          </button>
          <button
            onClick={() => {
              onSearchAddSongs();
              setIsOpen(false);
            }}
            className={menuItemClass}
          >
            {t("searchAddSongs")}
          </button>
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
